module.exports = __webpack_public_path__ + "media/images/forms-icons/number-icon-hover-fd28b5959ab06a95fb89c45ddd876f05.svg";